import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsSidebarItems } from './settingsSidebarItems';
import { SettingsSidebarItem } from './SettingsSidebarItem';
import { SettingsLanguageItem } from './SettingsLanguageItem';

export const SettingsSidebar = () => {
  const { t } = useTranslation();
  const settingsSidebarGroups = useSettingsSidebarItems();

  return (
    <aside
      className="tw-flex tw-flex-col tw-gap-4 tw-border-r tw-border-grayscale-20 tw-bg-white tw-py-4 tw-pl-4 tw-pr-2"
      style={{ width: 220 }}
      data-cy="settings_sidebar"
    >
      {settingsSidebarGroups.map((group) => (
        <div key={group.key} className="tw-flex tw-flex-col tw-gap-2">
          <div className="tw-px-2 tw-text-xs tw-font-medium tw-uppercase tw-text-grayscale-100">
            {t(group.label)}
          </div>
          {group.items.map((item) => {
            if (item.type === 'language') {
              return <SettingsLanguageItem key={item.key} />;
            }
            return <SettingsSidebarItem key={item.key} item={item} />;
          })}
        </div>
      ))}
    </aside>
  );
};
